import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authActions } from './auth';

interface VaultiLakeState {
  selectedCustomerId: string | null;
  selectedClientId: string | null;
}

const initialState: VaultiLakeState = {
  selectedCustomerId: null,
  selectedClientId: null,
};

const vaultiLakeSlice = createSlice({
  name: 'vaultiLake',
  initialState,
  reducers: {
    setLakehouseSelection(state, action: PayloadAction<{ customerId: string | null; clientId: string | null }>) {
      state.selectedCustomerId = action.payload.customerId;
      state.selectedClientId = action.payload.clientId;
    },
    clearLakehouseSelection(state) {
      state.selectedCustomerId = null;
      state.selectedClientId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authActions.logout, () => {
      return initialState;
    });
  },
});

export const { setLakehouseSelection, clearLakehouseSelection } = vaultiLakeSlice.actions;
export default vaultiLakeSlice.reducer;